<template lang="pug">
    div.report-data(v-if="currentComponent")
        component(
            :is="currentComponent"
            ref="reportDataComponent"
        )
</template>

<script>
export default {
    name: 'ReportData',
    data() {
        return {
            components: {
                'PY': () => import('@/modules/traceability-report/views/components/shared/form/report-data/content.vue')
            }
        };
    },
    computed: {
        currentComponent() {
            const user = this.$store.state.usuarioLogado;
            return this.components[user.paisGrupo];
        }
    }
};
</script>

<style scoped lang="scss">
h3 {
    margin: 16px 0;
    color: #3B3B3B;
    font-weight: 500;
    font-size: 16px;
}
</style>
